export default "__VITE_ASSET__BVKF$_la__"